import { Text } from '@chakra-ui/react';
import { useAppSelector } from '@hooks/redux.hooks';
import { selectHeightSuffix } from '@redux/settings/settings.selectors';
import { FormattedMessage } from 'react-intl';

export default function FlightPlansHeader() {
  const showHeightSuffix = useAppSelector(selectHeightSuffix);
  return (
    <>
      <Text width="200px" fontWeight="medium" color="neutral.500">
        <FormattedMessage id="components.flightPlans.flightPlan" />
      </Text>
      <Text width="368px" fontWeight="medium" color="neutral.500">
        <FormattedMessage id="components.flightPlans.date" />
      </Text>
      <Text width="96px" fontWeight="medium" color="neutral.500">
        <FormattedMessage id="components.flightPlans.height" />
        {showHeightSuffix && <FormattedMessage id="target.agl" />}
      </Text>
      <Text width="160px" fontWeight="medium" color="neutral.500">
        <FormattedMessage id="components.flightPlans.source" />
      </Text>
      <Text width="64px" fontWeight="medium" color="neutral.500">
        <FormattedMessage id="components.flightPlans.status" />
      </Text>
      <Text width="68px" fontWeight="medium" color="neutral.500">
        <FormattedMessage id="components.flightPlans.conflict" />
      </Text>
    </>
  );
}
